import { IdName } from '../../../shared/models';
import { EmployeeClockLog } from './employee-clock-log';

export class LocationEmployeeLog extends IdName {

    employees: EmployeeClockLog[] = [];

    constructor(data: any) {
        super();
        Object.assign(this, data);
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/shared/models/location-employee-log.ts